import SentrySDK from 'common/3rd/SentrySDK';
import Message from 'common/message/Message';
import LocalStorage from 'common/storage/LocalStorage';
import devURL from 'common/util/devURL';

import 'common/Polyfills';

const CannyOrigin = devURL('https://canny.io');
const ProductSeenID = 'canny-product-seen';
const SentryDSN = 'bbea399b6ea844ffb0585987df0757da';

SentrySDK.init(SentryDSN);

Message.subscribe(window.parent, CannyOrigin, 'get-product-seen', () => {
  const result = LocalStorage.get(ProductSeenID);
  Message.postMessage(window.parent, CannyOrigin, 'return-product-seen', result);
});

Message.subscribe(window.parent, null, 'set-product-seen', ({ subdomain }) => {
  LocalStorage.set(ProductSeenID, JSON.stringify({ subdomain }));
});
